import ResourcesCollectionProto from "./resources-collection-proto"
import Resources from "../resources"
import Project from "../../model2/project/project"

export default class ProjectsResourcesCollection extends ResourcesCollectionProto {
    constructor(resources:Resources, data: any[] = [], options:any = {}) {
        super(resources, data, Project, options)
    }
}